





















import Vue from "vue";
export default Vue.extend({
    props: {
        label: {
            type: String,
            required: true
        },
        value: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            required: true
        },
        selected: {
            type: String,
            required: true
        }
    },
    computed: {
        isSelected: function(): boolean {       // <-- explicit return type
            return this.selected === this.value;
        },
        formattedPropertyLabel: function(): string {  // <-- explicit return type
            if (!this.label) {
                return "";
            }
            return this.label.charAt(0) + this.label.slice(1).toLowerCase();
        }
    }
});
